import {makeStyles} from "@material-ui/core/styles";

const theme = (props) => {
  const styles = makeStyles(theme => ({
    pageWrapper: {
      fontSize: "14px",
      padding: "1rem",
      margin: "0 auto"
    },
    topBar: {
      marginBottom:" 1.25rem"
    },
    titleWrapper: {
      '& h1': {
        fontSize: "22px",
        fontWeight: 500
      }
    },
    inputWrapper: {
      display: "flex",
      alignItems: "center"
    },
    alertBox: {
      display: "flex",
      alignItems: "flex-start",
      gap: "14px",
      background: "#fffbf0",
      border: "0.5px solid #f5c542",
      borderRadius: "8px",
      padding: "14px 18px",
      marginBottom: "1.25rem",

      "& strong": {
        fontWeight: 500,
        fontSize: "14px",
        display: "block",
        marginBottom: "6px"
      },

      "& p": {
        fontSize: "13px",
        color: "#555",
      },

      "& p:first-of-type": {
        marginBottom: "0px",
        marginTop: "0px"
      },

      "& p:last-of-type": {
        marginTop: "0px"
      }
    },
    alertIcon: {
      fontSize: "22px",
      color: "#d97706",
      marginTop: "1px"
    },
    alertBoxTextWrapper: {
      paddingTop: "6px"
    },
    cardsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(4,1fr)",
      gap: "12px",
      marginBottom: "1.25rem"
    },
    statCard: {
      background: "#fff",
      border: "0.5px solid #e0e0e0",
      borderRadius: "12px",
      padding: "16px",

      "& h3": {
        fontSize: "14px",
        fontWeight: 500
      }
    },
    statCardIcon: {
      width: "36px",
      height: "36px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "18px",
      flexShrink: 0
    },
    icBlue: {
      background: "#eff6ff",
      color: "#2563eb"
    },
    icGreen: {
      background: "#f0fdf4",
      color: "#16a34a"
    },
    icPurple: {
      background: "#f5f3ff",
      color: "#7c3aed"
    },
    icOrange: {
      background: "#fff7ed",
      color: "#ea580c"
    },
    statCardHeader: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      marginBottom: "12px"
    },
    statRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "3px 0",
      fontSize: "13px",

      "& span:first-child": {
        color: "#666"
      }
    },
    valGreen: {
      color: "#16a34a",
      fontWeight: 500
    },
    valRed: {
      color: "#dc2626",
      fontWeight: 500
    },
    eventsSection: {
      background: "#fff",
      border: "0.5px solid #e0e0e0",
      borderRadius: "12px",
      padding: "18px",
      marginBottom: "1rem",
      position: "relative"
    },
    eventsHeader: {
      marginBottom: "6px",

      "& h2": {
        fontSize: "16px",
        fontWeight: 500,
        display: "inline"
      }
    },
    eventsCount: {
      fontSize: "16px",
      fontWeight: 500,
      color: "#888",
      marginLeft: "8px"
    },
    eventsDesc: {
      fontSize: "13px",
      color: "#666",
      marginBottom: "14px"
    },
    eventsTable: {
      width: "100%",
      borderCollapse: "collapse",

      "& th": {
        fontSize: "12px",
        color: "#888",
        fontWeight: 500,
        textAlign: "left",
        padding: "8px 10px",
        borderBottom: "0.5px solid #e8e8e8"
      },

      "& td": {
        fontSize: "13px",
        padding: "10px 10px",
        borderBottom: "0.5px solid #e8e8e8",
        verticalAlign: "middle"
      },

      "& tr:last-child": {
        borderBottom: "none"
      }
    },
    emptyState: {
      textAlign: "center",
      color: "#666",
      borderBottom: "none !important",
      paddingTop: "28px !important"
    },
    showAllBtn: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      color: "#2563eb",
      fontSize: "13px",
      cursor: "pointer",
      marginTop: "14px",
      paddingTop: "14px",
      borderTop: "0.5px solid #e8e8e8",
      background: "none",
      borderLeft: "none",
      borderRight: "none",
      borderBottom: "none",
      width: "100%",

      "& svg": {
        marginTop: "-3px"
      }
    },
    moreNote: {
      fontSize: "12px",
      color: "#aaa",
      paddingTop: "8px",
      marginTop: 0
    },
    accordion: {
      background: "#fff",
      border: "0.5px solid #e0e0e0",
      borderRadius: "12px",
      overflow: "hidden",
      marginBottom: "1rem"
    },
    accordionHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "15px 18px",
      cursor: "pointer",
      fontSize: "13px",
      color: "#666",
      userSelect: "none",

      "&:hover": {
        background: "#fafafa"
      }
    },
    accordionHeaderLeft: {
      display: "flex",
      alignItems: "center",
      gap: "8px",

      "& svg": {
        width: "0.8em",
        height: "0.8em"
      }
    },
    accChevron: {
      transition: "transform 0.2s",
    },
    accordionBody: {
      padding: "16px 18px",
      fontSize: "12px",
      color: "#555",
      lineHeight: 1.8,
      borderTop: "0.5px solid #e8e8e8",
      whiteSpace: "pre-wrap",
      wordBreak: "break-all"
    }
  }));
  return styles();
}
export default theme;
